<template>
    <!-- 帮助与支持全部 -->
    <div class="help">
        <div class="swiper-slide" v-for="(value, index) in components" :key="index">
            <component :is="value.name" :key="index" v-bind="value" />
        </div>
    </div>
</template>
<script>
import Help from './Help.vue';
import HelpDetails from './HelpDetails.vue';
export default {
    name: 'helpAll',
    components: {
        Help,
        HelpDetails
    },
    data() {
        return {
            components: [
                {
                    name: 'Help'
                }, {
                    name: 'HelpDetails',
                    inx: '1'
                },
                {
                    name: 'HelpDetails',
                    inx: '2'
                },
                {
                    name: 'HelpDetails',
                    inx: '3'
                },
                {
                    name: 'HelpDetails',
                    inx: '4'
                }
            ]
        }
    }
}
</script>
<style lang="scss" scoped></style>
